const { jsPDF } = require('../../../node_modules/jspdf');
const configs = require('./../configs');
const html2canvas = require('./../libs/html2canvas.min.js');
const { getParamValue } = require('./functions');
require('./../../../node_modules/jspdf-autotable');
require('./../../../node_modules/jquery.cookie');

var doc, pageWidth, lastHeight;
var count_question = 1;

/**
 * First section of QM
 * @param {Object} doc
 */
function informations_section(doc) {
	doc.autoTable({
		theme: 'grid',
		margin: { horizontal: 5, top: lastHeight },
		headStyles: { fillColor: [248, 249, 250], textColor: [0, 0, 0], lineWidth: 1 },
		head: [[{ content: 'Renseignement sur le patient', colSpan: 2 }, { content: 'Responsable du paiement des frais et honoraires', colSpan: 2 }]],
		columnStyles: {
			0: {cellWidth: 140},
			1: {cellWidth: 80}
		},
		body: [
			[{ content: 'Sexe' }, { content: $('input[name="sexe"]:checked').val() }, { content: '', colSpan: 2 }],
			[{ content: 'Nom' }, { content: $('input[name="nom"]').val(), styles: { cellWidth: 80 } }, { content: 'Nom' }, { content: $('input[name="responsable_nom"]').val(), styles: { cellWidth: 80 } }],
			[{ content: 'Prénom' }, { content: $('input[name="prenom"]').val() }, { content: 'Prénom' }, { content: $('input[name="responsable_prenom"]').val() }],
			[{ content: 'Email' }, { content: $('input[name="courriel"]').val() }, { content: '', colSpan: 2 }],
			[{ content: 'Adresse' }, { content: $('input[name="adresse"]').val() }, { content: 'Adresse' }, { content: $('input[name="responsable_adresse"]').val() }],
			[{ content: 'Ville' }, { content: $('input[name="ville"]').val() + ($('input[name="codepostal"]').val() ? ', ' + $('input[name="codepostal"]').val() : '') }, { content: 'Ville' }, { content: $('input[name="responsable_ville"]').val() + ($('input[name="responsable_codepostal"]').val() ? ', ' + $('input[name="responsable_codepostal"]').val() : '') }],
			[{ content: 'Tél. domicile' }, { content: $('input[name="teldomicile_patient"]').val() }, { content: 'Tél. domicile' }, { content: $('input[name="responsable_teldomicile"]').val() }],
			[{ content: 'Tél. mobile' }, { content: $('input[name="telmobile"]').val() }, { content: 'Tél. mobile' }, { content: $('input[name="responsable_telmobile"]').val() }],
			[{ content: 'Tél. travail' }, { content: $('input[name="telbureau"]').val() + ($('input[name="poste_patient"]').val() ? ', Poste : ' + $('input[name="poste_patient"]').val() : '') }, { content: 'Tél. travail' }, { content: $('input[name="responsable_telbureau"]').val() + ($('input[name="responsable_poste"]').val() ? ', Poste : ' + $('input[name="responsable_poste"]').val() : '') }],
			[{ content: 'Date de naissance' }, { content: $('input[name="annee"]').val() + '/' + $('input[name="mois"]').val() + '/' + $('input[name="jour"]').val(), colSpan: 3 }],
			[{ content: 'Assurance maladie' }, { content: 'Numéro : ' + $('input[name="numeroassurance"]').val() + ($('input[name="month_expiration"]').val() ? ', Expiration : ' + $('input[name="month_expiration"]').val() + '/' + $('input[name="year_expiration"]').val() : ''), colSpan: 3 }],
			[{ content: 'Si vous avez moins de 18 ans, inscrire le nom du parent : ' + $('input[name="parent"]').val() + ' OU du tuteur : ' + $('input[name="tutor"]').val(), colSpan: 4}],
			[{ content: 'Référé par : ' + $('input[name="reference"]').val(), colSpan: 2 }, { content: count_question + '. Êtes-vous bénéficiaire d\'un programme d\'aide sociale au Québec ?' + ' ' + $('input[name="question_1"]:checked').val(), colSpan: 2 }]
		]
	});
	count_question = count_question + 1;
}

/**
 * First covid section of QM
 * @param {Object} doc
 */
function informations_covid_section(doc) {
	doc.autoTable({
		theme: 'grid',
		margin: { horizontal: 5, top: lastHeight },
		headStyles: { fillColor: [248, 249, 250], textColor: [0, 0, 0], lineWidth: 1 },
		head: [[{ content: 'Renseignement sur le patient', colSpan: 2 }]],
		body: [
			[{ content: 'Nom' }, { content: $('input[name="nom"]').val(), styles: { cellWidth: 140 } }],
			[{ content: 'Prénom' }, { content: $('input[name="prenom"]').val() }],
			[{ content: 'Email' }, { content: $('input[name="courriel"]').val() }],
			[{ content: 'Date de naissance' }, { content: $('input[name="year_birthday"]').val() + '/' + $('input[name="month_birthday"]').val() + '/' + $('input[name="day_birthday"]').val()}]
		]
	});
}

/**
 * QM section generator
 * @param {Object} doc
 */
function section_generator(doc) {

	$('section.body').each(function() {
		var t_body = [];
		var fill_colors = ['Oui', 'Un peu', 'Beaucoup', 'Ronflement', 'Apnée'];
		$(this).find('.step-section').not('.hide').each(function() {
			$(this).children().each(function () {
	
				if ($(this).hasClass('step-title')) {
	
					if ($(this).find('.title').length) {
						t_body.push([{ content: $(this).find('.title').text(), colSpan: 2, styles: { halign: 'center', fillColor: [248, 249, 250], textColor: [0, 0, 0], fontStyle: 'bold', fontSize: 12 } }]);
					}

					if ($(this).find('.step-sub-title').length) {
						t_body.push([{ content: $(this).find('.step-sub-title').text(), colSpan: 2, styles: { fontStyle: 'bold', fontSize: 10 } }]);
					}
	
				} else if ($(this).hasClass('step-questions') && !$(this).hasClass('hide')) {
	
					var l_step_questions = $(this).find('.wrapper-question').length;
					var c_step_questions = 0;
					
					$(this).children().each(function () {

						if ($(this).hasClass('step-sub-title')) {
							t_body.push([{ content: $(this).text(), colSpan: 2, styles: { fontStyle: 'bold', fontSize: 10 } }]);
						} else if ($(this).hasClass('wrapper-question')) {
	
							if (c_step_questions < l_step_questions) {
								
								if ($(this).attr('data-question-type') == 'choice') {
									var list_text = '';
									if ($(this).attr('data-list-details')) {
										var list_details = $(this).attr('data-list-details').split(',');
										list_details.forEach(element => {
											if (element !== 'undefined') {
												list_text += '\n - ' + element;	
											}
										});
									}

									t_body.push([{ content: count_question + '. ' + $(this).attr('data-question') + (list_text !== '' ? list_text : '') }, { content: $('input[name="'+$(this).attr('data-name')+'"]:checked').val(), styles: { fillColor: (jQuery.inArray($('input[name="'+$(this).attr('data-name')+'"]:checked').val(), fill_colors) !== -1) ? [255, 255, 0]: null, cellWidth: 60, halign: 'center', valign: 'middle' } }]);

									if ($('textarea[name="'+$(this).attr('data-name')+'_specify"]').val()) {
										t_body.push([{ content: $(this).attr('data-specify-text') + ' ' + $('textarea[name="'+$(this).attr('data-name')+'_specify"]').val(), colSpan: 2 }]);
									}

									if ($('input[name="'+$(this).attr('data-name')+'_date"]').val()) {
										t_body.push([{ content: 'Quand ? ' + $('input[name="'+$(this).attr('data-name')+'_date"]').val(), colSpan: 2 }]);
									}

								}

								if ($(this).attr('data-question-type') == 'textarea') {
									t_body.push([{ content: count_question + '. ' + $(this).attr('data-question') + ($('textarea[name="'+$(this).attr('data-name')+'"]').val() ? (/[:?]$/.test($(this).attr('data-question')) ? ' ' : ' : ') + $('textarea[name="'+$(this).attr('data-name')+'"]').val() : ''), colSpan: 2 }]);
								}

								if ($(this).attr('data-question-type') == 'text') {
									t_body.push([{ content: count_question + '. ' + $(this).attr('data-question') + ($('input[name="'+$(this).attr('data-name')+'"]').val() ? (/[:?]$/.test($(this).attr('data-question')) ? ' ' : ' : ') + $('input[name="'+$(this).attr('data-name')+'"]').val() : ''), colSpan: 2 }]);
								}
	
							}
	
							c_step_questions = c_step_questions + 1;
	
						}

						count_question = count_question + 1;
	
					});
	
				}
	
			});
	
		});

		if (t_body.length > 0) {
			doc.autoTable({
				theme: 'grid',
				margin: { horizontal: 5, top: 10 },
				body: t_body
			});
		}

	});
	
}

/**
 * QM precautions section
 * @param {Object} doc
 */
function precautions_generator(doc) {
	var t_body = [];
	t_body.push([{ content: 'Précautions opératoires - À l\'usage du professionnel', colSpan: 2, styles: { halign: 'center', fillColor: [248, 249, 250], textColor: [0, 0, 0], fontStyle: 'bold', fontSize: 12 } }]);
	t_body.push([{ content: '', colSpan: 2, styles: { minCellHeight: 80 } }]);

	if (t_body.length > 0) {
		doc.autoTable({
			theme: 'grid',
			margin: { horizontal: 5, top: 10 },
			body: t_body
		});
	}

}

/**
 * QM consentement section
 * @param {Object} doc
 */
function consentement_generator(doc) {
	var t_body = [];
	t_body.push([{ content: 'Consentement à communiquer avec un professionnel de la santé', colSpan: 2, styles: { halign: 'center', fillColor: [248, 249, 250], textColor: [0, 0, 0], fontStyle: 'bold', fontSize: 12 } }]);
	t_body.push([{ content: 'Nom' }, { content: $('input[name="consentement_professionnel_name"]').val(), styles: { cellWidth: 60, halign: 'center' } }]);
	t_body.push([{ content: 'Fonction' }, { content: $('input[name="consentement_professionnel_function"]').val(), styles: { cellWidth: 60, halign: 'center' } }]);
	t_body.push([{ content: 'Établissement' }, { content: $('input[name="consentement_professionnel_establishment"]').val(), styles: { cellWidth: 60, halign: 'center' } }]);
	t_body.push([{ content: 'Téléphone' }, { content: $('input[name="consentement_professionnel_telephone"]').val(), styles: { cellWidth: 60, halign: 'center' } }]);

	if (t_body.length > 0) {
		doc.autoTable({
			theme: 'grid',
			margin: { horizontal: 5, top: 10 },
			body: t_body
		});
	}

}

/**
 * QM signature section
 * @param {Object} doc
 * @param {String} imgData
 */
function signature_generator(doc, imgData) {
	var t_body = [];
	var d = new Date();
	var strDate = d.getDate() + '/' + ((d.getMonth()+1) < 10 ? '0' + (d.getMonth()+1) : '' + (d.getMonth()+1)) + '/' + d.getFullYear();
	t_body.push([{ content: 'Signature du patient ou du responsable', colSpan: 2, styles: { halign: 'center', fillColor: [248, 249, 250], textColor: [0, 0, 0], fontStyle: 'bold', fontSize: 12 } }]);
	t_body.push([{ content: '', colSpan: 2, styles: { minCellHeight: 80 } }]);
	t_body.push([{ content: 'Date : ' + strDate, colSpan: 2, styles: { halign: 'center', fontStyle: 'bold', fontSize: 10 } }]);

	if (t_body.length > 0) {
		doc.autoTable({
			theme: 'grid',
			margin: { horizontal: 5, top: 10 },
			body: t_body,
			didDrawCell: function(data) {
				if (data.row.index === 1) {
					const img = new Image();
					img.src = imgData;
					img.onload = function() {
						const imgHeight = img.naturalHeight;
						if (imgData) {
							doc.addImage(imgData, (data.cell.x + (data.cell.width / 2) - 100), data.cell.y - (data.cell.height / 2 - (imgHeight / 2)));
						}
					};

				}
			}
		});
	}

	t_body = [];
	t_body.push([{ content: 'Membre du personnel de la clinique', colSpan: 2, styles: { halign: 'center', fillColor: [248, 249, 250], textColor: [0, 0, 0], fontStyle: 'bold', fontSize: 12 } }]);
	t_body.push([{ content: 'Nom : ', colSpan: 2 }]);
	t_body.push([{ content: 'Signature', colSpan: 2, styles: { minCellHeight: 50 } }]);

	if (t_body.length > 0) {
		doc.autoTable({
			theme: 'grid',
			margin: { horizontal: 5, top: 10 },
			body: t_body
		});
	}

}

/**
 * Create QM PDF
 */
function createPDF() {
	doc = new jsPDF('p', 'px', 'letter');
	doc.setFont('helvetica');
	doc.setFontSize(8);
	pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
	lastHeight = 5;
	var img = new Image();
	img.src = '/microsite/images/logo-ordre-dentistes-quebec.jpeg';
	doc.addImage(img, 'JPEG', 5, lastHeight, 90, 30);
	lastHeight = lastHeight + 50;
	doc.setFontSize(15).setFont('helvetica', 'bold');
	doc.text('Questionnaire médical confidentiel', pageWidth / 2, lastHeight, {align: 'center'});
	doc.setFontSize(8);
	lastHeight = lastHeight + 10;
	count_question = 1;
	const COVID_FORM = getParamValue('covid');

	if (COVID_FORM === 'true') {
		informations_covid_section(doc);
	} else {
		informations_section(doc);	
	}

	section_generator(doc);
	doc.addPage();
	precautions_generator(doc);

	if (COVID_FORM !== 'true') {
		consentement_generator(doc);	
	}

	html2canvas($(document).find('canvas.pad')[0], { allowTaint: true }).then(function(canvas) {
		var imgData = canvas.toDataURL('image/png', 1.0);
		signature_generator(doc, imgData);
	});
}

// Send PDF
function sendPDF() {
	$('body').addClass('loading');
	createPDF();
	setTimeout(function() {
		// Generate output pdf object
		var output = doc.output('blob');
		var reader = new FileReader();
		reader.readAsDataURL(output); 
		reader.onloadend = function() {
			var base64data = reader.result.substr(reader.result.indexOf(',') + 1);
			var formData = new FormData();
			formData.name = $('input[name="prenom"]').val() + ' ' + $('input[name="nom"]').val();
			formData.email = $('input[name="courriel"]').val();
			formData.clinic = getParamValue('id');
			formData.file = base64data;
			$.ajax({
				type: 'post',
				url: `${configs.apiUrl}/email/form`,
				data: JSON.stringify(formData),
				contentType: 'application/json; charset=utf-8',
				dataType : 'json',
				success: function (response) {
					if (response.statusCode == 202) {
						$.cookie('qm-success', 1);
						window.location.replace(`${configs.micrositeUrl}/?id=`+getParamValue('id'));
					} else {
						$.cookie('qm-error', 1);
						window.location.replace(`${configs.micrositeUrl}/?id=`+getParamValue('id'));
					}
				},
				error: function () {
					$.cookie('qm-error', 1);
					window.location.replace(`${configs.micrositeUrl}/?id=`+getParamValue('id'));
				}
			});
		};
	}, 2000);
}

module.exports = {
	sendPDF
};